import { request } from "../utils/request.js"

export const versionRecord_getLastVersionInfo = (args) => request({
    url: 'versionRecord/getLastVersionInfo',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const versionRecord_getLastEnableVersionInfoByVersionRecordTypeEnumAndTenantCode = (versionRecordTypeEnum, tenantCode, args) => request({
    url: 'versionRecord/getLastEnableVersionInfoByVersionRecordTypeEnumAndTenantCode',
    method: 'GET',
    params: {
        versionRecordTypeEnum: versionRecordTypeEnum,
        tenantCode: tenantCode
    },
    showFailMessage: true,
    ...args
})



// WEBPACK FOOTER //
// ./src/api/versionRecord.js